import { AxiosService } from '../../../../services/axiosService';

export const getLogsApi = pagination => {
  return AxiosService.get('/change/list', {}, { pagination });
};
